import NumericFieldPrimitive from './NumericFieldPrimitive';
import { INumericFieldPrimitive } from './NumericFieldPrimitive.interfaces';

export default NumericFieldPrimitive;
export { NumericFieldPrimitive, INumericFieldPrimitive };
